import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  saveButton: {
    justifySelf: 'flex-end',
  },
}));

export default useStyles;
